/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import Badge from '@atlaskit/badge/badge'` instead.
 */
export { default } from './badge';
/**
 * @deprecated Use `import type { BadgeProps, BadgeNewProps } from '@atlaskit/badge/types'` instead.
 */
export type { BadgeProps, BadgeNewProps } from './types';
